import * as React from "react";
import { FaChevronDown, FaChevronRight } from "react-icons/fa";
import styled from "styled-components";
import { ICourseInstructionContentPart } from "../../../../course-author/types";
import theme from "../../../../../styles/theme";
import ClickableElement from "../../../../utils/ClickableElement";
import { H2 } from "../../../../utils/Headings";
import { ControlBar } from "./ControlBar";
import { CancelDragZone } from "../../../../../context/UseDragAndDrop";
import CloneArrows from "../../../../utils/Icons/CloneArrows";
import { TooltipWrapper } from "../../../../pages/Analytics/FilterCriteria/FilterCriteria";

interface IInstructionPartHeaderProps {
  deletePart: () => void;
  edit: boolean;
  showBackground: boolean;
  expanded: boolean;
  title: string;
  toggleEdit: () => void;
  toggleExpanded: () => void;
  toggleBackgroundOptions: () => void;
  part: ICourseInstructionContentPart;
}

export const HeaderRow = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  gap: 2rem;
`;

export const Title = styled(H2)`
  align-items: center;
  display: flex;
  flex-direction: row;
  font-size: ${theme.primaryFontSize};
  justify-content: flex-start;
`;

const ExpandButton = styled(ClickableElement)`
  width: 5rem;
`;

const InstructionHeaderContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
`;

const cancelDragZoneStyle = {
  alignItems: "center",
  display: "flex",
  flexDirection: "row",
  flexGrow: 1,
  justifyContent: "space-between",
} as React.CSSProperties;

const InstructionPartHeader: React.FC<IInstructionPartHeaderProps> = props => {
  return (
    <InstructionHeaderContainer>
      <CancelDragZone customStyle={cancelDragZoneStyle}>
        <Title>
          <ExpandButton onClick={props.toggleExpanded}>
            {props.expanded ? <FaChevronDown /> : <FaChevronRight />}
          </ExpandButton>
          {props.title}
        </Title>
        <ControlBar
          part={props.part}
          showBackgroundOptions={props.showBackground}
          editing={props.edit}
          onEdit={props.toggleEdit}
          onDelete={props.deletePart}
          onBackgroundClick={props.toggleBackgroundOptions}
        />
      </CancelDragZone>
      <TooltipWrapper
        id="dnd-block"
        content="Clone across tabs"
        containerStyle={{
          padding: "0.5rem",
        }}
      >
        <CloneArrows />
      </TooltipWrapper>
    </InstructionHeaderContainer>
  );
};

export default InstructionPartHeader;
